import Grid from '@mui/material/Grid';
import React, { useState, useEffect } from 'react'
import { format } from 'date-fns'
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { Checkbox, Button } from '.'
import Text from './Text'
import AnonymizedEmailsList from './lgpd/AnonymizedEmailsList';
import { useApp } from '../../contexts';
import { useParams } from 'react-router-dom';

export default function Filters(props) {

    const { handleSearchButton } = props
    const { showDialog } = useApp();
    const [value, setValue] = useState('')
    const { accessToken } = useParams()

    function onChange(event) {
        const { value } = event.target
        setValue(value)
    }

    const [dateValue, setDateValue] = React.useState(new Date())

    const handleChange = (newValue) => {
        setDateValue(newValue);
    };

    const blackListModal = async () => {
        showDialog({
            title: `BlackList`,
            component: <AnonymizedEmailsList accessToken={accessToken}/>,
            fullWidth: true
        })
    }

    return (
        <>
            <Grid container sx={{ marginBottom: 2 }}>
                <TextField
                    sx={{ marginRight: 2, minWidth: 400 }}
                    size="small"
                    placeholder="Digite o nome, e-mail ou telefone do contato"
                    value={value}
                    label={value.length > 0 ? "Usuário" : "Digite o nome, e-mail ou telefone do contato"}
                    variant="outlined"
                    onChange={onChange}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            handleSearchButton(value)
                        }
                    }}
                />
                {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Stack spacing={3}>
                        <DesktopDatePicker
                            value={dateValue}
                            onChange={handleChange}
                            label="Data atualização"
                            // inputFormat="dd/MM/yyyy"
                            inputFormat="dd/MM/yyyy"
                            renderInput={(params) => <TextField {...params} size="small" />}
                        />
                    </Stack>
                </LocalizationProvider> */}
                <div style={{display: 'flex', alignItems: 'center', marginRight: 15}}>
                    <Checkbox />
                    <Text>Testes</Text>
                </div>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <Button 
                    sx={{ backgroundColor: "#04577F", 
                        color: '#FFF', 
                        height: 40, 
                        transition: '0.2s',
                        textTransform: "capitalize", 
                        '&:hover': {
                            backgroundColor: "#04577F",
                            opacity: 0.7
                        } 
                    }} 
                    onClick={() => blackListModal()}
                    >
                        BlackList
                    </Button>
                </div>
                
            </Grid>
        </>
    )
}
